// extracted by mini-css-extract-plugin
export var buttons = "Steps-module--buttons--7c65a";
export var content = "Steps-module--content--83365";
export var descC = "Steps-module--descC--eda95";
export var image = "Steps-module--image--9f842";
export var itemC = "Steps-module--itemC--99d80";
export var list = "Steps-module--list--e94a5";
export var number = "Steps-module--number--bb44e";
export var root = "Steps-module--root--21938";